$(document).ready(function () {
  const $desc = $(".product-page .product-description");
  const $action = $desc.find(".product-description__action");
  if ($desc.length && $action.length) {
    if ($desc[0].scrollHeight <= $desc[0].clientHeight + 8) {
      $action.hide();
    } else {
      $action.on("click", function () {
        const expanded = !$desc.hasClass("active");
        $desc.toggleClass("active", expanded);
        $action.attr("aria-expanded", expanded ? "true" : "false");
        $action.attr("aria-label", expanded ? "閉じる" : "展開");
      });
    }
  }

  const bottomBar = document.querySelector(".product-bottom__bar");
  const isElementVisible = (element) => {
    if (!element || element.classList.contains("z-index-1")) return false;
    const style = window.getComputedStyle(element);
    if (
      style.display === "none" ||
      style.visibility === "hidden" ||
      Number(style.opacity) === 0
    ) {
      return false;
    }
    return element.getBoundingClientRect().height > 0;
  };
  const getFloatingTabbarBottom = () => {
    let bottom = 0;
    document.querySelectorAll(".common-tabbar-outer-container.enable_sticky").forEach((tabbar) => {
      if (!isElementVisible(tabbar)) return;
      const rect = tabbar.getBoundingClientRect();
      if (rect.top > 16 || rect.bottom <= 0) return;
      bottom = Math.max(bottom, Math.round(rect.bottom));
    });
    return bottom;
  };
  const stickyTabbars = [
    ...document.querySelectorAll(".common-tabbar-outer-container.enable_sticky"),
  ];
  const syncMobileViewportBars = () => {
    const viewport = window.visualViewport;
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportHeight = viewport ? viewport.height : window.innerHeight;
    const viewportBottom = viewportTop + viewportHeight;

    bottomBar.style.removeProperty("transform");
    const bottomRect = bottomBar.getBoundingClientRect();
    const bottomShift = Math.round(viewportBottom - bottomRect.bottom);
    if (bottomShift) {
      bottomBar.style.transform = `translate3d(0, ${bottomShift}px, 0)`;
    }

    stickyTabbars.forEach((tabbar) => {
      tabbar.style.removeProperty("transform");
      if (!isElementVisible(tabbar)) return;
      const rect = tabbar.getBoundingClientRect();
      if (rect.top > viewportTop + 2) return;
      const topShift = Math.round(viewportTop - rect.top);
      if (topShift) {
        tabbar.style.transform = `translate3d(0, ${topShift}px, 0)`;
      }
    });
  };
  const placeBottomBar = () => {
    if (!bottomBar) return;
    if (window.innerWidth < 850) {
      bottomBar.style.removeProperty("--product-bottom-top");
      syncMobileViewportBars();
      return;
    }
    bottomBar.style.removeProperty("transform");
    stickyTabbars.forEach((tabbar) => tabbar.style.removeProperty("transform"));
    const headerSection = document.querySelector(
      "#shopify-section-header, #shopify-section-header-classic"
    );
    const header = document.querySelector(".site-header");
    const tabbarBottom = getFloatingTabbarBottom();
    let top = 0;
    if (tabbarBottom > 0) {
      top = Math.max(0, tabbarBottom - 1);
    } else if (header && isElementVisible(headerSection || header) && isElementVisible(header)) {
      top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    bottomBar.style.setProperty("--product-bottom-top", top + "px");
  };
  let placeFrame = 0;
  const schedulePlaceBottomBar = () => {
    if (placeFrame) return;
    placeFrame = window.requestAnimationFrame(() => {
      placeFrame = 0;
      placeBottomBar();
    });
  };
  placeBottomBar();
  window.addEventListener("scroll", schedulePlaceBottomBar, { passive: true });
  window.addEventListener("resize", schedulePlaceBottomBar);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("scroll", schedulePlaceBottomBar, { passive: true });
    window.visualViewport.addEventListener("resize", schedulePlaceBottomBar);
  }

  const watchTargets = [
    ...stickyTabbars,
    document.querySelector("#shopify-section-header"),
    document.querySelector("#shopify-section-header-classic"),
  ].filter(Boolean);
  if (watchTargets.length && "ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(schedulePlaceBottomBar);
    watchTargets.forEach((element) => resizeObserver.observe(element));
  }
  if (watchTargets.length && "MutationObserver" in window) {
    const mutationObserver = new MutationObserver(schedulePlaceBottomBar);
    watchTargets.forEach((element) => {
      mutationObserver.observe(element, {
        attributes: true,
        attributeFilter: ["class", "style"],
      });
    });
  }
});

if (!customElements.get("product-anchor-nav")) {
  customElements.define(
    "product-anchor-nav",
    class ProductAnchorNav extends HTMLElement {
      connectedCallback() {
        if (this._isBound) return;
        this._isBound = true;

        this.querySelectorAll("[data-scroll-target]").forEach((button) => {
          button.addEventListener("click", () => {
            const target = this.getVisibleTarget(button.dataset.scrollTarget);
            if (!target) return;

            const top =
              target.getBoundingClientRect().top +
              window.scrollY -
              this.getStickyOffset();
            const reduceMotion = window.matchMedia(
              "(prefers-reduced-motion: reduce)"
            ).matches;

            window.scrollTo({
              top: Math.max(0, top),
              behavior: reduceMotion ? "auto" : "smooth",
            });
          });
        });
      }

      getVisibleTarget(selector) {
        if (!selector) return null;
        return (
          Array.from(document.querySelectorAll(selector)).find(
            (element) => element.getClientRects().length > 0
          ) || null
        );
      }

      getStickyOffset() {
        const header = document.querySelector(
          "#shopify-section-header, #shopify-section-header-classic"
        );
        const tabbar = document.querySelector(
          ".common-tabbar-outer-container.enable_sticky"
        );
        const headerHeight = header?.offsetHeight || 0;
        const tabbarHeight = tabbar?.offsetHeight || 0;
        return headerHeight + tabbarHeight + 12;
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {

  const videoWrappers = document.querySelectorAll('.product-single__media-wrapper');
  
  videoWrappers.forEach(wrapper => {
    // Check if this is a video wrapper
    if (wrapper.querySelector('video') || wrapper.querySelector('iframe')) {
      // Create play button
      const playButton = document.createElement('div');
      playButton.className = 'video-play-button';
      playButton.innerHTML = `
        <svg class="play-icon" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
        <svg class="pause-icon" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>
      `;
      wrapper.appendChild(playButton);
      
      // Find video element
      const video = wrapper.querySelector('video');
      const iframe = wrapper.querySelector('iframe');
      
      if (video) {
        // Keep product videos paused by default and let users start playback manually.
        video.muted = false;
        video.playsinline = true;
        video.autoplay = false;
        video.loop = true;
        
        // Handle video play/pause
        playButton.addEventListener('click', function() {
          if (video.paused) {
            video.play();
            playButton.querySelector('.play-icon').style.display = 'none';
            playButton.querySelector('.pause-icon').style.display = 'block';
          } else {
            video.pause();
            playButton.querySelector('.play-icon').style.display = 'block';
            playButton.querySelector('.pause-icon').style.display = 'none';
          }
        });
        
        // Update button state when video starts playing
        video.addEventListener('play', function() {
          playButton.querySelector('.play-icon').style.display = 'none';
          playButton.querySelector('.pause-icon').style.display = 'block';
        });
        
        // Update button state when video is paused
        video.addEventListener('pause', function() {
          playButton.querySelector('.play-icon').style.display = 'block';
          playButton.querySelector('.pause-icon').style.display = 'none';
        });
        
        // Update button state when video ends
        video.addEventListener('ended', function() {
          playButton.querySelector('.play-icon').style.display = 'block';
          playButton.querySelector('.pause-icon').style.display = 'none';
        });
      } else if (iframe) {
        // Handle iframe video (YouTube, Vimeo, etc.)
        playButton.addEventListener('click', function() {
          // For iframe videos, we can't directly control playback
          // but we can simulate a click on the iframe
          const iframeRect = iframe.getBoundingClientRect();
          const clickX = iframeRect.width / 2;
          const clickY = iframeRect.height / 2;
          
          // Create a click event on the iframe
          const event = new MouseEvent('click', {
            clientX: iframeRect.left + clickX,
            clientY: iframeRect.top + clickY,
            bubbles: true,
            cancelable: true,
            view: window
          });
          
          iframe.dispatchEvent(event);
        });
      }
    }
  });

  //
  const productThumbs = new Swiper(".product-thumbs__swiper", {
    slidesPerView: 9,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    initialSlide: 0,
    slideActiveClass: "product-thumbs__swiper-slide--active",
    breakpoints: {
      849: {
        slidesPerView: 6,
      },
    },
  });

  const productImages = new Swiper(".product-image__swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    threshold: 10,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-button-next.product-image__swiper-btn",
      prevEl: ".swiper-button-prev.product-image__swiper-btn",
    },
    pagination: {
      el: ".product-image__pagination",
      clickable: true,
    },
    thumbs: {
      swiper: productThumbs,
    },
    on: {
      slideChange: function () {
        document.querySelectorAll(".product-thumbs__item").forEach((item) => {
          item.classList.remove("active");
        });
        const activeIndex = this.realIndex;
        const activeThumb = document.querySelectorAll(".product-thumbs__item")[activeIndex];
        if (activeThumb) activeThumb.classList.add("active");
        const counterCurrent = document.querySelector(".product-image__counter-current");
        if (counterCurrent) counterCurrent.textContent = String(activeIndex + 1);
      },
    },
  });
  const productImagesIndex = document
    .querySelector(".product-media")
    .getAttribute("data-media-index");
  productImages.slideTo(Number(productImagesIndex) - 1);
  const counterCurrent = document.querySelector(".product-image__counter-current");
  if (counterCurrent) counterCurrent.textContent = String(productImages.realIndex + 1);

  const refreshProductGallery = () => {
    window.requestAnimationFrame(() => {
      productThumbs.update();
      productImages.update();
    });
  };
  $(document.body).on("ajaxCart.afterCartLoad", refreshProductGallery);

  const initProductDemoSwiper = (el) => {
    if (!el || typeof Swiper === "undefined") return null;
    const styles = getComputedStyle(el);
    const readNumber = (prop, fallback) => {
      const value = parseFloat(styles.getPropertyValue(prop));
      return Number.isFinite(value) ? value : fallback;
    };
    const spaceBetween = readNumber("--swiper-gap", 10);
    return new Swiper(el, {
      slidesPerView: readNumber("--swiper-per-view-pc", 2.8),
      spaceBetween,
      watchOverflow: true,
      grabCursor: true,
      threshold: 8,
      preventClicks: false,
      preventClicksPropagation: false,
      observer: true,
      observeParents: true,
      breakpoints: {
        849: {
          slidesPerView: readNumber("--swiper-per-view-m", 2.5),
          spaceBetween,
        },
      },
    });
  };

  const demoSwipers = [];
  let accessoriesSwiper = null;
  const updateDemoBleed = () => {
    document.querySelectorAll(".product-demo__swiper, .product-accessories__swiper").forEach((el) => {
      let content = el.closest(".product-content");
      if (!content || getComputedStyle(content).display === "contents") {
        content = el.parentElement || el;
      }
      const right = content.getBoundingClientRect().right;
      const viewportRight = document.documentElement.clientWidth;
      const bleed = Math.max(0, Math.floor(viewportRight - right));
      el.style.setProperty("--demo-bleed", `${bleed}px`);
    });
    demoSwipers.forEach((swiper) => swiper.update());
  };

  updateDemoBleed();
  document.querySelectorAll(".product-demo__swiper, .product-accessories__swiper").forEach((el) => {
    const swiper = initProductDemoSwiper(el);
    if (!swiper) return;
    demoSwipers.push(swiper);
    if (el.classList.contains("product-accessories__swiper")) accessoriesSwiper = swiper;
  });
  window.addEventListener("resize", updateDemoBleed);

  const finalPriceEle = document.querySelector(".product-bottom__price .price");
  const finalComparePriceEle = document.querySelector(
    ".product-bottom__price .compare-price"
  );
  const productBuyBtn = document.querySelector(".product-payment-btn");
  const productAddBtn = document.querySelector(".product-add-cart-btn");
  const accessoriesItems = document.querySelectorAll(
    ".product-accessories__item"
  );
  const state = {
    _basePrice: parseInt(finalPriceEle.dataset.price, 10),
    _baseComparePrice: finalComparePriceEle
      ? parseInt(finalComparePriceEle.dataset.price, 10)
      : 0,

    selectedIds: 0,
    accessoryQty: new Map(),
    accessoriesTotal: 0,
    accessoriesCompareTotal: 0,

    get totalPrice() {
      return this._basePrice + this.accessoriesTotal;
    },
    get totalComparePrice() {
      return this._baseComparePrice + this.accessoriesCompareTotal;
    },
  };
  if (productBuyBtn || productAddBtn) {
    state.selectedIds = new Set([productBuyBtn.dataset.variantId]);
  }

  if (productBuyBtn || productAddBtn) {

    const createPriceObserver = (element, callback) => {
      return new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "data-price") {
            callback(parseInt(element.dataset.price, 10));
          }
        });
      }).observe(element, { attributes: true });
    };

    createPriceObserver(finalPriceEle, (newPrice) => {
      state._basePrice = newPrice;
      updatePriceDisplay();
    });

    if (finalComparePriceEle) {
      createPriceObserver(finalComparePriceEle, (newPrice) => {
        state._baseComparePrice = newPrice;
        updatePriceDisplay();
      });
    }

    const updateSystem = (isAdding, { id, price, comparePrice, qty }) => {
      const quantity = qty || 1;
      if (isAdding) {
        state.selectedIds.add(id);
        state.accessoryQty.set(id, quantity);
        state.accessoriesTotal += price * quantity;
        state.accessoriesCompareTotal += comparePrice * quantity;
      } else {
        const prevQty = state.accessoryQty.get(id) || quantity;
        state.selectedIds.delete(id);
        state.accessoryQty.delete(id);
        state.accessoriesTotal -= price * prevQty;
        state.accessoriesCompareTotal -= comparePrice * prevQty;
      }

      updatePriceDisplay();
      updateVariantIds();
    };

    const updateBottomBadges = (price, comparePrice) => {
      const discountEle = document.querySelector("[data-bottom-discount]");
      const cashbackEle = document.querySelector("[data-bottom-cashback]");
      if (discountEle) {
        if (comparePrice > price) {
          discountEle.hidden = false;
          discountEle.textContent = `${Math.floor(((comparePrice - price) * 100) / comparePrice)}% OFF`;
        } else {
          discountEle.hidden = true;
          discountEle.textContent = "";
        }
      }
      if (cashbackEle) {
        const yen = Math.floor(price / 2000) * 100;
        cashbackEle.textContent = `${yen.toLocaleString("ja-JP")}円還元`;
      }
    };

    const updatePriceDisplay = () => {
      if (!finalPriceEle) {
        console.warn('Price display elements not found');
        return;
      }

      if (!state || typeof state.totalPrice === 'undefined' || typeof state.totalComparePrice === 'undefined') {
        console.warn('State or required price properties are missing');
        return;
      }

      const formatPriceWithTax = (price) => `${formatMoney(price)}<span class="price-tax">(税込)</span>`;

      finalPriceEle.innerHTML = formatPriceWithTax(state.totalPrice);
      if (finalComparePriceEle) {
        const compareVisible = state.totalComparePrice > state.totalPrice;
        finalComparePriceEle.hidden = !compareVisible;
        finalComparePriceEle.textContent = compareVisible
          ? `${formatMoney(state.totalComparePrice)}(税込)`
          : "";
      }
      updateBottomBadges(state.totalPrice, state.totalComparePrice);
    };

    const updateVariantIds = () => {
      const ids = [...state.selectedIds];
      const quantities = ids.map((id, index) => {
        if (index === 0) return "1";
        return String(state.accessoryQty.get(id) || 1);
      });
      const idsString = ids.join(",");
      const qtyString = quantities.join(",");
      [productBuyBtn, productAddBtn].forEach((btn) => {
        if (!btn) return;
        btn.dataset.variantId = idsString;
        btn.dataset.quantity = qtyString;
      });
    };

    accessoriesItems.forEach((item) => {
      const accessory = {
        id: item.dataset.id,
        price: parseInt(
          item.dataset.price ||
            item.querySelector(".accessories-price .price")?.dataset.price ||
            0,
          10
        ),
        comparePrice: parseInt(
          item.dataset.comparePrice ||
            item.querySelector(".accessories-price .compare-price")?.dataset
              .price ||
            0,
          10
        ),
        get qty() {
          return parseInt(item.querySelector(".accessories-qty__value")?.textContent, 10) || 1;
        },
      };

      const setQty = (nextQty) => {
        const max = parseInt(item.dataset.max, 10) || 99;
        const qty = Math.min(max, Math.max(1, nextQty));
        const valueEl = item.querySelector(".accessories-qty__value");
        const minusBtn = item.querySelector(".accessories-qty__btn--minus");
        const plusBtn = item.querySelector(".accessories-qty__btn--plus");
        if (valueEl) valueEl.textContent = String(qty);
        if (minusBtn) minusBtn.disabled = qty <= 1;
        if (plusBtn) plusBtn.disabled = qty >= max;
        return qty;
      };

      const applyQty = (delta) => {
        const qty = setQty(accessory.qty + delta);
        if (!item.classList.contains("active")) {
          item.classList.add("active");
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox) checkbox.checked = true;
          updateSystem(true, { ...accessory, qty });
          return;
        }
        const prevQty = state.accessoryQty.get(accessory.id) || 1;
        const diff = qty - prevQty;
        if (!diff) return;
        state.accessoryQty.set(accessory.id, qty);
        state.accessoriesTotal += accessory.price * diff;
        state.accessoriesCompareTotal += accessory.comparePrice * diff;
        updatePriceDisplay();
        updateVariantIds();
      };

      item.querySelector(".accessories-qty")?.addEventListener("click", (event) => {
        event.stopPropagation();
        if (accessoriesSwiper && accessoriesSwiper.animating) return;
        const btn = event.target.closest(".accessories-qty__btn");
        if (!btn || btn.disabled) return;
        const delta = btn.classList.contains("accessories-qty__btn--plus") ? 1 : -1;
        applyQty(delta);
      });

      item.addEventListener("click", function (event) {
        if (event.target.closest(".accessories-qty")) return;
        if (accessoriesSwiper && accessoriesSwiper.animating) return;
        const isActive = this.classList.toggle("active");
        const checkbox = this.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = isActive;
        updateSystem(isActive, { ...accessory, qty: accessory.qty });
      });
    });
  }

  function formatMoney(cents, format) {
    var moneyFormat = "${{amount}}";
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.theme.moneyFormat || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  class HTMLUpdateUtility {
    static viewTransition(
      oldNode,
      newContent,
      preProcessCallbacks = [],
      postProcessCallbacks = []
    ) {
      preProcessCallbacks?.forEach((callback) => callback(newContent));

      const newNodeWrapper = document.createElement("div");
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;

      // dedupe IDs
      const uniqueKey = Date.now();
      oldNode.querySelectorAll("[id], [form]").forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`);
        element.form &&
          element.setAttribute(
            "form",
            `${element.form.getAttribute("id")}-${uniqueKey}`
          );
      });

      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = "none";

      postProcessCallbacks?.forEach((callback) => callback(newNode));

      setTimeout(() => oldNode.remove(), 500);
    }

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(
          document.createTextNode(oldScriptTag.innerHTML)
        );
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }

  class VariantSelects extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);
        publish("optionValueSelectionChange", {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector(
        "variant-selects [data-selected-variant]"
      )?.innerHTML;
      return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    updateURL(url, variantId) {
      this.querySelector("share-button")?.updateUrl(
        `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
      );

      if (this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${url}${variantId ? `?variant=${variantId}` : ""}`
      );
    }

    updateSelectionMetadata({ target }) {
      const { value, tagName } = target;

      if (tagName === "SELECT" && target.selectedOptions.length) {
        Array.from(target.options)
          .find((option) => option.getAttribute("selected"))
          .removeAttribute("selected");
        target.selectedOptions[0].setAttribute("selected", "selected");

        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = target
          .closest(".product-form__input")
          .querySelector("[data-selected-value] > .swatch");
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty(
            "--swatch--background",
            swatchValue
          );
          selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
        } else {
          selectedDropdownSwatchValue.style.setProperty(
            "--swatch--background",
            "unset"
          );
          selectedDropdownSwatchValue.classList.add("swatch--unavailable");
        }

        selectedDropdownSwatchValue.style.setProperty(
          "--swatch-focal-point",
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
        );
      } else if (tagName === "INPUT" && target.type === "radio") {
        const selectedSwatchValue = target
          .closest(`.product-form__input`)
          .querySelector("[data-selected-value]");
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    get selectedOptionValues() {
      return Array.from(
        this.querySelectorAll("select option[selected], fieldset input:checked")
      ).map(({ dataset }) => dataset.optionValueId);
    }
  }

  customElements.define("variant-selects", VariantSelects);

  if (!customElements.get("product-info")) {
    customElements.define(
      "product-info",
      class ProductInfo extends HTMLElement {
        quantityForm = undefined;
        onVariantChangeUnsubscriber = undefined;
        cartUpdateUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];

        constructor() {
          super();
        }

        connectedCallback() {
          this.initializeProductSwapUtility();

          this.onVariantChangeUnsubscriber = subscribe(
            "optionValueSelectionChange",
            this.handleOptionValueChange.bind(this)
          );

          this.dispatchEvent(
            new CustomEvent("product-info:loaded", { bubbles: true })
          );
        }

        addPreProcessCallback(callback) {
          this.preProcessHtmlCallbacks.push(callback);
        }

        disconnectedCallback() {
          this.onVariantChangeUnsubscriber();
          this.cartUpdateUnsubscriber?.();
        }

        initializeProductSwapUtility() {
          this.preProcessHtmlCallbacks.push((html) =>
            html
              .querySelectorAll(".scroll-trigger")
              .forEach((element) =>
                element.classList.add("scroll-trigger--cancel")
              )
          );
          this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
          });
        }

        handleOptionValueChange({
          data: { event, target, selectedOptionValues },
        }) {
          if (!this.contains(event.target)) return;

          this.resetProductFormState();

          const productUrl =
            target.dataset.productUrl ||
            this.pendingRequestUrl ||
            this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage =
            this.dataset.updateUrl === "true" && shouldSwapProduct;

          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(
              productUrl,
              selectedOptionValues,
              shouldFetchFullPage
            ),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
        }

        resetProductFormState() {
          const productForm = this.productForm;
          productForm?.toggleSubmitButton(true);
          productForm?.handleErrorMessage();
        }

        handleSwapProduct(productUrl, updateFullPage) {
          return (html) => {
            this.productModal?.remove();

            const selector = updateFullPage
              ? "product-info[id^='MainProduct']"
              : "product-info";
            const variant = this.getSelectedVariant(
              html.querySelector(selector)
            );
            this.updateURL(productUrl, variant?.id);

            if (updateFullPage) {
              document.querySelector("head title").innerHTML =
                html.querySelector("head title").innerHTML;

              HTMLUpdateUtility.viewTransition(
                document.querySelector("main"),
                html.querySelector("main"),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            } else {
              HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector("product-info"),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            }
          };
        }

        renderProductInfo({ requestUrl, targetId, callback }) {
          this.abortController?.abort();
          this.abortController = new AbortController();

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              callback(html);
            })
            .then(() => {
              // set focus to last clicked option value
              document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
              if (error.name === "AbortError") {
                console.log("Fetch aborted by user");
              } else {
                console.error(error);
              }
            });
        }

        getSelectedVariant(productInfoNode) {
          const selectedVariant = productInfoNode.querySelector(
            "variant-selects [data-selected-variant]"
          )?.innerHTML;
          return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }

        buildRequestUrlWithParams(
          url,
          optionValues,
          shouldFetchFullPage = false
        ) {
          const params = [];

          !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(",")}`);
          }

          return `${url}?${params.join("&")}`;
        }

        updateOptionValues(html) {
          const variantSelects = html.querySelector("variant-selects");
          if (variantSelects) {
            HTMLUpdateUtility.viewTransition(
              this.variantSelectors,
              variantSelects,
              this.preProcessHtmlCallbacks
            );
          }
        }

        handleUpdateProductInfo(productUrl) {
          return (html) => {
            const variant = this.getSelectedVariant(html);

            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);
            this.updateURL(productUrl, variant?.id);
            this.updateVariantInputs(variant?.id);
            this.updateButtonVariant(variant?.id);
            this.updateprice(variant);
            this.updatePoint(variant);
            this.setAvailable(variant);

            if (!variant) {
              this.setUnavailable();
              return;
            }

            this.updateMedia(html, variant?.featured_media?.position);

            const updateSourceFromDestination = (
              id,
              shouldHide = (source) => false
            ) => {
              const source = html.getElementById(`${id}-${this.sectionId}`);
              const destination = this.querySelector(
                `#${id}-${this.dataset.section}`
              );
              if (source && destination) {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle("hidden", shouldHide(source));
              }
            };

            updateSourceFromDestination("price");
            updateSourceFromDestination("Sku", ({ classList }) =>
              classList.contains("hidden")
            );
            updateSourceFromDestination(
              "Inventory",
              ({ innerText }) => innerText === ""
            );
            updateSourceFromDestination("Volume");
            updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
              classList.contains("hidden")
            );

            this.querySelector(
              `#Quantity-Rules-${this.dataset.section}`
            )?.classList.remove("hidden");
            this.querySelector(
              `#Volume-Note-${this.dataset.section}`
            )?.classList.remove("hidden");

            this.productForm?.toggleSubmitButton(
              html
                .getElementById(`ProductSubmitButton-${this.sectionId}`)
                ?.hasAttribute("disabled") ?? true,
              window.variantStrings.soldOut
            );

            publish("variantChange", {
              data: {
                sectionId: this.sectionId,
                html,
                variant,
              },
            });
          };
        }

        updateVariantInputs(variantId) {
          this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
        }

        updateButtonVariant(variantId) {
          if (!variantId) return;
          let idArray = Array.from(state.selectedIds);
          idArray[0] = variantId;
          state.selectedIds = new Set(idArray);
          const ids = [...state.selectedIds];
          const quantities = ids.map((id, index) => {
            if (index === 0) return "1";
            return String(state.accessoryQty.get(id) || 1);
          });
          const idsString = ids.join(",");
          const qtyString = quantities.join(",");
          const addCartButton = document.querySelector("add-cart-button");
          const buyNowButton = document.querySelector("buy-now-button");
          [addCartButton, buyNowButton].forEach((btn) => {
            if (!btn) return;
            btn.setAttribute("data-variant-id", idsString);
            btn.setAttribute("data-quantity", qtyString);
          });
        }

        updateprice(variant) {
          const price = variant.price;
          const comparePrice = variant.compare_at_price;
          const bottomPrice = document.querySelector("[data-bottom-price]");
          
          if (!bottomPrice) return;
          
          const priceElement = bottomPrice.querySelector(".price");
          const comparePriceElement = bottomPrice.querySelector(".compare-price");
          
          if (priceElement) {
            priceElement.setAttribute("data-price", price);
            priceElement.innerHTML = `${formatMoney(price)}<span class="price-tax">(税込)</span>`;
          }
          
          if (comparePriceElement && comparePrice) {
            comparePriceElement.setAttribute("data-price", comparePrice);
            comparePriceElement.innerHTML = `${formatMoney(comparePrice)}(税込)`;
          }
        }

        updatePoint(variant) {
          const price = variant.price;
          const ptPriceEle = document.querySelector(".pt-price");
          const ptConvPriceEle = document.querySelector(".pt-conv-price");

          if (ptPriceEle) {
            ptPriceEle.innerHTML = price / 100;
          }
          if (ptConvPriceEle) {
            ptConvPriceEle.innerHTML = price / 2000;
          }

        }

        updateURL(url, variantId) {
          this.querySelector("share-button")?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
          );

          if (this.dataset.updateUrl === "false") return;
          window.history.replaceState(
            {},
            "",
            `${url}${variantId ? `?variant=${variantId}` : ""}`
          );
        }

        setUnavailable() {
          this.productForm?.toggleSubmitButton(
            true,
            window.variantStrings.unavailable
          );

          const selectors = [
            "price",
            "Inventory",
            "Sku",
            "Price-Per-Item",
            "Volume-Note",
            "Volume",
            "Quantity-Rules",
          ]
            .map((id) => `#${id}-${this.dataset.section}`)
            .join(", ");
          document
            .querySelectorAll(selectors)
            .forEach(({ classList }) => classList.add("hidden"));
        }

        setAvailable(variant) {
          const addCartButton = document.querySelector("add-cart-button");
          const buyNowButton = document.querySelector("buy-now-button");
          if (variant.available) {
            addCartButton.classList.remove("product-btn--sold-out");
            buyNowButton.classList.remove("product-btn--sold-out");
            addCartButton.querySelector("span").innerHTML = "カートに追加する";
            buyNowButton.querySelector("span").innerHTML = "今すぐ購入";
          } else {
            addCartButton.classList.add("product-btn--sold-out");
            buyNowButton.classList.add("product-btn--sold-out");
            addCartButton.querySelector("span").innerHTML = "売り切れ";
            buyNowButton.querySelector("span").innerHTML = "売り切れ";
          }
        }

        updateMedia(html, variantFeaturedMediaId) {
          if (!variantFeaturedMediaId) return;
          productImages.slideTo(variantFeaturedMediaId - 1);
        }

        get productForm() {
          return this.querySelector(`product-form`);
        }

        get productModal() {
          return document.querySelector(
            `#ProductModal-${this.dataset.section}`
          );
        }

        get pickupAvailability() {
          return this.querySelector(`pickup-availability`);
        }

        get variantSelectors() {
          return this.querySelector("variant-selects");
        }

        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            "related-products"
          );
          return document.querySelector(
            `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
          );
        }

        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            "quick_order_list"
          );
          return document.querySelector(
            `quick-order-list[data-id^="${quickOrderListSectionId}"]`
          );
        }

        get sectionId() {
          return this.dataset.originalSection || this.dataset.section;
        }
      }
    );
  }
});

// Channel Popup
document.addEventListener("DOMContentLoaded", function () {
  const openModalBtn = document.querySelector(".channel-btn");
  if (openModalBtn) {
    const channelPopup = document.querySelector(".channel-popup");
    const popupInner = channelPopup.querySelector(".channel-popup__inner");
    const closeBtn = channelPopup.querySelector(".channel-popup__close");

    const preventDefaultScroll = (event) => {
      event.preventDefault();
    };

    if (openModalBtn) {
      openModalBtn.addEventListener("click", function () {
        channelPopup.classList.remove("popup-hidden");

        document.addEventListener("touchmove", preventDefaultScroll, {
          passive: false,
        });

        document.addEventListener("wheel", preventDefaultScroll, {
          passive: false,
        });
      });
    }

    function closeModal() {
      channelPopup.classList.add("popup-hidden");
      document.removeEventListener("touchmove", preventDefaultScroll);
      document.removeEventListener("wheel", preventDefaultScroll);
    }

    closeBtn.addEventListener("click", closeModal);

    channelPopup.addEventListener("click", function (e) {
      if (e.target === popupInner) {
        closeModal();
      }
    });
  }
});
